import React from 'react'

import { User } from 'panel/user/redux/types'

import { ReactComponent as CollaboratorIcon } from 'assets/icons/people.svg'

const Collaborator: React.FC<{ user: User }> = ({ user }) => {
  return (
    <div className="row panel margin-top-32">
      <h2 className="row justify-start">
        <CollaboratorIcon height="30" width="35" /> Colaborador
      </h2>

      <div className="row margin-top-16">
        <img
          alt="User Profile"
          style={{ width: 70, height: 70, borderRadius: '50%' }}
          src={user.person?.picture || `${process.env.PUBLIC_URL}/img/default-user.png`}
        />
        <div className="grow padding-left-16">
          <div className="row">
            <a className="grow" href={`/panel/user/${user.id}`} target="__blank">
              <h2 className="no-margin">{ user.person?.name }</h2>
              <p className="no-margin">{ user.person?.email || '...' }</p>
            </a>

            <div className="row" style={{ width: 400 }}>
              <p className="no-margin">E-mail</p>
              <h2 className="no-margin">{ user.person?.email }</h2>
            </div>
            <div className="row" style={{ width: 250 }}>
              <p className="no-margin">Telefone</p>
              <h2 className="no-margin">{ user.person?.phone || '(XX) X XXXX-XXXX' }</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Collaborator
